<template>
    <CompassTooltip :arrow="false" :content="textTooltip" :placement="tooltipPlacement">
        <slot>
            <CompassIconButton
                size="small"
                :icon="icon"
                :class="buttonClasses"
                @click="copyToClipboard"
            />
        </slot>
    </CompassTooltip>
</template>

<script>
import { handleCopyToClipboard } from 'Helpers/stringHelper';

export default {
    props: {
        data: {
            type: String,
            required: true,
        },
        tooltipPlacement: {
            type: String,
            default: 'bottom',
        },
        tooltipContent: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isCopied: false,
        };
    },
    computed: {
        icon() {
            return this.isCopied ? 'success-circle' : 'duplicate';
        },
        textTooltip() {
            if (this.isCopied) {
                return this.$t.__('common.label.copy_to_clipboard_success');
            }
            return this.tooltipContent || this.$t.__('common.actions.copy');
        },
        buttonClasses() {
            return {
                'copy-btn': true,
                'copy-btn--copied': this.isCopied,
            };
        },
    },
    methods: {
        async copyToClipboard() {
            try {
                await handleCopyToClipboard(this.data);
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                }, 3000);
            } catch {
                this.$pushToast({
                    type: 'error',
                    icon: true,
                    text: this.$t.__('common.label.copy_to_clipboard_error'),
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.copy-btn {
    display: inline-block;
    transform: translateX(-50%);
    position: relative;
    opacity: 0;
    transition: all 200ms ease-in-out;
}

.copy-element:hover,
.copy-element-fixed {
    .copy-btn {
        transform: translateX(5px);
        opacity: 1;
        cursor: pointer;

        &:hover {
            &::after {
                opacity: 1;
            }
        }
        &--copied {
            color: var(--colors-common-icon-success);
        }
    }
}
</style>
